import { Injectable } from '@angular/core';
import { NxSortHeaderIntl } from '@aposin/ng-aquila/table';

@Injectable()
// Ndbx grid column header sort labels, appear on mouse hover
export class SortHeaderIntl extends NxSortHeaderIntl {
    sortAscendingAriaLabel = 'click to sort ascending';
    sortDescendingAriaLabel = 'click to sort descending';
}